module.exports = __webpack_public_path__ + "static/media/backArrow.3eeb86f9.svg";